import { getRefName as e } from "./get-ref-name.js";
import { compositions as t } from "./schema-composition.js";
import { shouldRenderArrayItemComposition as n } from "./should-render-array-item-composition.js";
import { unwrapForRead as r } from "./unwrap-for-read.js";
import { isDefined as i } from "@scalar/helpers/array/is-defined";
import { unescapeJsonPointerSegment as a } from "@scalar/helpers/json/unescape-json-pointer-segment";
import { resolve as o } from "@scalar/workspace-store/resolve";
import { isArraySchema as s } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
//#region src/schema/helpers/get-compositions-to-render.ts
var c = (e) => e.startsWith("#/") || e.includes("/") ? e : `#/components/schemas/${e}`, l = (t, n, s) => {
	if (t.oneOf || t.anyOf) return null;
	let l = t.discriminator?.mapping;
	if (!l) return null;
	let u = r(n);
	if (!u?.components?.schemas) return null;
	let d = (s ?? Object.values(l)).filter((e) => typeof e == "string").map((t) => {
		let n = c(t), r = e(n), i = r ? o.schema(u.components?.schemas?.[a(r)]) : void 0;
		if (i) return {
			$ref: n,
			"$ref-value": i
		};
	}).filter(i);
	return d.length === 0 ? null : {
		...o.schema(t),
		oneOf: d
	};
}, u = (e, r, a = e ? l(e, r) : null) => e ? t.map((t) => t === "oneOf" && a ? {
	composition: t,
	value: a
} : n(e, t) && s(e) && e.items ? {
	composition: t,
	value: o.schema(e.items)
} : e[t] && !(s(e) && e.items && typeof e.items == "object" && t in e.items) ? {
	composition: t,
	value: o.schema(e)
} : null).filter(i) : [];
//#endregion
export { u as getCompositionsToRender, l as inferDiscriminatorMappingComposition };

//# sourceMappingURL=get-compositions-to-render.js.map